import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TopNavServiceService {
  isNavbarCollapsed = true;
  navbarStateChange$ = new Subject<boolean>();

  constructor() {
    this.navbarStateChange$.subscribe(value => {
      this.isNavbarCollapsed = value;
    });
  }

  toggleNavbarCollapse() {
    this.navbarStateChange$.next(!this.isNavbarCollapsed);
  }

  closeNavbar() {
    this.navbarStateChange$.next(true);
  }
}
